<form [formGroup]="formGerar" (ngSubmit)="GerarRelatorio()" aria-labelledby="form-title">
  <breadcrumb [paginas]="[
      {route:'/home',name:'Home'},
      {route:'/relatorio/atividade',name:'Relatório'}
    ]" aria-label="Navegação de breadcrumb" />

  <section class="section-saudacao">
    <div class="container">
      <h2 class="titulo-page mb-2">
        Relatório de Atividade do Psicólogo
      </h2>
    </div>
  </section>

  <section class="section-saudacao">
    <div class="container">
      <h3 class="titulo-page fs-4 mb-1">
        Gerar relatório
      </h3>
    </div>
  </section>

  <section class="section-filtro pt-3">
    <div class="container">
      <div class="grupo-filter">
        <label>Polo</label>
        <ng-select [items]="polos"
                   bindLabel="descricaoPolo"
                   bindValue="codigoPolo"
                   placeholder="Selecione um Polo"
                   name="codigoPolo"
                   formControlName="codigoPolo"
                   (change)="OnChangePolo()"
                   [ngClass]="{'is-invalid': submitted && form.codigoPolo.errors}">
        </ng-select>
        <div *ngIf="submitted && form.codigoPolo.errors" class="alert">
          <div *ngIf="form.codigoPolo.errors.required">
            * Polo é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter">
        <label>Data inicial</label>
        <input type="date"
               name="dataInicial"
               class="input-date"
               placeholder="Selecione a"
               formControlName="dataInicial"
               [ngClass]="{ 'is-invalid': submitted && form.dataInicial.errors }"
               aria-label="Data" />
        <div *ngIf="submitted && form.dataInicial.errors" class="alert">
          <div *ngIf="form.dataInicial.errors.required">
            * Data inicial é obrigatório
          </div>
        </div>
      </div>

      <div class="grupo-filter">
        <label>Data final</label>
        <input type="date"
               name="dataFinal"
               class="input-date"
               formControlName="dataFinal"
               [ngClass]="{ 'is-invalid': submitted && form.dataFinal.errors }"
               aria-label="Data" />
        <div *ngIf="submitted && form.dataFinal.errors" class="alert">
          <div *ngIf="form.dataFinal.errors.required">
            * Data final é obrigatório
          </div>
        </div>
      </div>

      <button type="submit" class="btn btn-primary py-2 mt-4 fs-4">
        Gerar relatório
      </button>
    </div>
  </section>

  <hr class="my-5 mx-4" style="border-top: 1px solid #ccc;" />

  <section class="conteudo-principal" aria-labelledby="detalhes-chamado-title">
    <div class="container">
      <h3 class="titulo-page fs-4">
        Relatórios gerados
      </h3>
      <div class="form-registro container-grid">
        <app-tabulator-table [tableData]="relatoriosGerados"
                             [columnNames]="colunasGrid"
                             [mostrarFiltro]="false"
                             [mostrarImprimir]="false"
                             [mostrarExportarHtml]="false"
                             [mostrarExportarExcel]="false"
                             [mostrarExportarPDF]="false"
                             [tipoRelatorio]="3"
                             [orientacaoPortrait]="false"></app-tabulator-table>
      </div>
    </div>
  </section>

</form>

<app-modal *ngIf="showModalConfirmacao">
  <div class="container-conviva form-registro modal-envolvidos">
    <div class="header-modal-calendario">
      <h2 class="titulo-page fs-3">
        Tem certeza que deseja gerar um relatório?
      </h2>
    </div>
    <div class="mt-4">
      <p class="fs-5">
        <span class="fs-5 fw-semibold">
          Atenção:
        </span>
        não será possível desfazer essa ação.
      </p>
    </div>
    <div class="mt-4">
      <div class="alert alert-primary" role="alert">
        <div class="d-flex align-items-center">
          <svg style="width:20px;" xmlns="http://www.w3.org/2000/svg" class="bi flex-shrink-0 me-2" viewBox="0 0 16 16" role="img" aria-label="Warning:">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
          </svg>
          <div class="m-0 text-justify">
            O sistema permite gerar dois relatórios por mês. Antes de confirmar, verifique se o período desejado já foi gerado.
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex mt-5 justify-content-end">
      <input type="button" class="btn_primary fs-4 me-4" value="Cancelar" (click)="FecharModalConfirmacao()" aria-label="Cancelar" />
      <input type="button" class="btn_outline fs-4" value="Confirmar" (click)="ConfirmarGeracao()" aria-label="Sim" />
    </div>
  </div>
</app-modal>

<ngx-spinner bdColor="rgba(51,51,51,0.8)"
             size="medium"
             color="#fff"
             type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
